// Formatage partagé par tous les écrans du module Rapports.

export const money = (v) => `${Number(v || 0).toLocaleString('fr-FR')} $`;
export const pct = (v) => `${Number(v || 0)} %`;
export const rate = (v) => `${Number(v || 0)}/mois`;

// Une durée nulle signifie « donnée non fiable » — on affiche « — », jamais 0.
export const days = (v) => (v === null || v === undefined ? '—' : `${v} j`);

export const dateTxt = (v) => (v ? new Date(v).toLocaleDateString('fr-FR') : '—');

// « il y a X j » (rupture, dernière vente…)
export const ago = (v) => {
  if (v === null || v === undefined) return '—';
  if (v <= 0) return "aujourd'hui";
  if (v === 1) return 'hier';
  return `il y a ${v} j`;
};

// Libellés courts de confiance pour les tableaux (le libellé long reste dans le détail).
export const CONFIANCE_COURT = {
  complete: 'Complet',
  estimated: 'Date estimée',
  incomplete: 'Incomplet',
};
